<template>
  <div class="container p-30 fs-16">
    <div class="logo mb-20 py-20"><img src="https://sky-production.s3.amazonaws.com/brandportalimages/ace-hotel-logo.png" /></div>
    <div class="mb-20">WIFI PORTAL</div>
    <div class="mb-20 connect-buttons">
      <button v-show="!connect_method" @click="handleClickMethod(1)">Hotel Guest</button>
      <div class="connect-method-form" v-if="connect_method === 1">
        <div class="mb-20"><input v-model="form.last_name" type="text" placeholder="Last Name" /></div>
        <div class="mb-20"><input v-model="form.room_number" type="text" placeholder="Room Number" /></div>
        <div class="mb-20 fs-14">
          <TermsOfService variant="checkbox" consent_text="I AGREE TO THE" consent_action_text="TERMS &amp; CONDITIONS" @onChangeCheckboxConsent="handleOnChangeCheckboxConsent" />
        </div>
        <div class="mb-20 fs-14">
          <label class="d-flex align-items-start"><input v-model="subscribe" type="checkbox" /><span class="ml-5">Join the A-List for secret codes, events and big announcements.</span></label>
        </div>
        <div class="mb-20" v-if="subscribe">
          <input v-model="form.email_address" type="text" placeholder="Email Address" />
        </div>
        <div class="mb-30">
          <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Continue</button>
        </div>
        <a href="#" class="d-block" @click.prevent="handleClickMethod()">Oops, take me back</a>
      </div>

      <button v-show="!connect_method" @click="handleClickMethod(2)">Visitor</button>
      <div class="connect-method-form" v-if="connect_method === 2">
        <div class="mb-20">
          <input v-model="form.first_name" type="text" placeholder="First Name" />
        </div>
        <div class="mb-20">
          <input v-model="form.last_name" type="text" placeholder="Last Name" />
        </div>
        <div class="mb-20">
          <input v-model="form.email_address" type="text" placeholder="Email" />
        </div>
        <div class="mb-20 fs-14">
          <label class="d-flex align-items-start"><input v-model="subscribe" type="checkbox" /><span class="ml-5">Join the A-List for secret codes, events and big announcements.</span></label>
        </div>
        <div class="mb-20 fs-14">
          <TermsOfService variant="checkbox" consent_text="I AGREE TO THE" consent_action_text="TERMS &amp; CONDITIONS" @onChangeCheckboxConsent="handleOnChangeCheckboxConsent" />
        </div>
        <div class="mb-30">
          <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Continue</button>
        </div>
        <a href="#" class="d-block" @click.prevent="handleClickMethod()">Oops, take me back</a>
      </div>
    </div>
    <div class="py-30">
      <SupportAndDeviceInfo :phone="portal.template.support_phone" :ip="connection_data.client_ip" :mac="connection_data.client_mac" />
    </div>
  </div>
  </template>
  
  <script>
  import TermsOfService from '@/utilities/TermsOfService'
  import SupportAndDeviceInfo from '@/utilities/SupportAndDeviceInfo'
  import Axios from "axios";

  export default {
    name: 'custom_template_ace_hotel',
    props: [ 'template', 'portal', 'connection_data', 'revinate_token' ],
    components: { TermsOfService, SupportAndDeviceInfo },
    computed: {
      show_continue:function(){
        if(this.connect_method === 1) return this.consent && this.form.last_name && this.form.room_number;
        if(this.connect_method === 2) return (this.consent && !this.subscribe) || (this.consent && this.subscribe && this.form.first_name && this.form.last_name && this.form.email_address);
      },
    },
    data(){
      return{
        revinate_url: 'https://contact-api.inguest.com/api/add-contacts-to-lists',
        disabled: true,
        connect_method: null,
        consent: false,
        subscribe: false,
        form: {
          // access_code: null,
          room_number: null,
          first_name: null,
          last_name: null,
          email_address: null,
        },
      }
    },
    watch: {
      'form': {
        deep: true,
        handler(){ this.disabled = false }
      }
    },
    created(){
      document.documentElement.classList.add('aceHotel');
    },
    methods: {
      handleOnChangeCheckboxConsent(value){
        this.consent = value;
      },
      handleClickMethod(method=null){
        this.disabled = false;
        this.connect_method = method;
        this.consent = false;
        this.subscribe = false;
        this.form.room_number = null;
        this.form.first_name = null;
        this.form.last_name = null;
        this.form.email_address = null;

      },
      setRegistrationData(){
        if(this.connect_method === 1){
          const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 2);
          const rateplan_id = registration_method.rate_plans[0].rateplan_id;
          return {
            registration_method_id: 2,
            rateplan_id: rateplan_id,
            last_name: this.form.last_name,
            room_number: this.form.room_number,
            email_address: this.form.email_address
          }
        } else if(this.connect_method === 2) {
          const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 1);
          const rateplan_id = registration_method.rate_plans[0].rateplan_id;
          return {
            registration_method_id: 1,
            rateplan_id: rateplan_id,
            ...(this.form.first_name && { first_name: this.form.first_name }),
            ...(this.form.last_name && { last_name: this.form.last_name }),
            ...(this.form.email_address && { email_address: this.form.email_address }),
          }
        }
      },
      handleClickConnect: function(){
        this.disabled = true;
        const data = this.setRegistrationData();
        if(this.form.email_address){
          const revinate_data = {
            tokens: [ this.revinate_token ],
            contacts: [
              {
                ...(this.form.first_name && { first_name: this.form.first_name }),
                ...(this.form.last_name && { last_name: this.form.last_name }),
                ...(this.form.email_address && { email: this.form.email_address }),
                 subscribed: this.subscribe
              }
            ]
          };
          Axios.post(this.revinate_url,revinate_data).then(response => {
            this.$emit('emitRegistrationMethodData', data );
          }).catch( error => {
            this.$emit('error', 'Error registering with email address.');
          });
        } else {
          this.$emit('emitRegistrationMethodData', data );
        }
      },
    }
  }
  </script>
  <style>
  .aceHotel { overflow-y: scroll; min-height: 100%; background: #fff; font-size: 20px;  }
  .aceHotel body { min-height: 100vh; background-image: url(https://sky-production.s3.amazonaws.com/brandportalimages/ace-hotel-background-header.jpg), url(https://sky-production.s3.amazonaws.com/brandportalimages/ace-hotel-background-body.jpg); background-position: left top, left top; background-repeat: repeat-x, repeat; }
  .aceHotel .container { background-color: unset; border-radius: unset; }
  .aceHotel .connect-method-form { width: 100%; text-align: left;  }
  .aceHotel #app, .aceHotel button, .aceHotel input[type="text"] { color: #000; }
  .aceHotel .connect-buttons { display: flex; margin: 0 -5px; }
  .aceHotel .connect-buttons > button { margin: 0 5px; border: 2px solid rgba(0, 0, 0, 0.5); color: rgba(0, 0, 0, 0.7); background: none; font-size: 20px; font-family: "Courier Prime", courier, "Courier New", monospace; }
  .aceHotel button { border: unset; cursor: pointer; line-height: 1; background: #231f20; color: #ffffff; width: 100%; padding: 20px 0; font-size: 16px; text-transform: uppercase;  }
  .aceHotel button[disabled] { cursor: not-allowed; }
  .aceHotel input[type="text"] { padding: 20px 22px; font-size: 20px; border: 1px solid #999; width: 100%;}
  .aceHotel .d-block { display: block; }
  .aceHotel a { color: #6B6B6B; }
  .aceHotel a:hover { color: #1a1a1a; }
  </style>
  